import React from "react";

import {
  InputLabel,
  TextField,
  Checkbox,
  FormControlLabel,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const OriginDesc = ({
  originForm,
  handleChange,
  validationErrors,
  deliveryMethods,
  originId = "",
  contacts,
  onContactChange,
  onAddContact,
  onRemoveContact,
}) => {
  return (
    <div className="origin-desc">
      <div className="d-flex ms-3">
        <div className="me-4 w-100">
          <InputLabel>Name </InputLabel>
          <TextField
            name="name"
            value={originForm.name}
            sx={{ width: "100%" }}
            onChange={handleChange}
            error={Boolean(validationErrors?.name)}
            helperText={validationErrors?.name}
            disabled={Boolean(originId)}
            InputProps={{
              readOnly: Boolean(originId), // Read-only only when editing an existing origin
            }}
          />
        </div>
      </div>

      <div className="ms-3 mt-4">
        <InputLabel>Contacts</InputLabel>

        {contacts.map((contact, index) => {
          const contactError = validationErrors?.contacts?.[index] || {};
          return (
            <div
              key={index}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1.3fr 1fr 1.4fr",
                gap: "12px",
                alignItems: "start",
                marginTop: "10px",
              }}>
              <TextField
                label="First Name"
                value={contact.firstname}
                sx={{ width: "100%" }}
                onChange={(e) =>
                  onContactChange(index, "firstname", e.target.value)
                }
                error={Boolean(contactError.firstname)}
                helperText={contactError.firstname}
              />
              <TextField
                label="Last Name"
                value={contact.lastname}
                sx={{ width: "100%" }}
                onChange={(e) =>
                  onContactChange(index, "lastname", e.target.value)
                }
              />
              <TextField
                label="Email"
                type="email"
                value={contact.email}
                sx={{ width: "100%" }}
                onChange={(e) =>
                  onContactChange(index, "email", e.target.value)
                }
                error={Boolean(contactError.email)}
                helperText={contactError.email}
              />
              <PhoneInput
                country={"au"}
                specialLabel={false}
                countryCodeEditable={true}
                enableSearch={false}
                countryFormat={true}
                value={contact.phone}
                onChange={(value) => onContactChange(index, "phone", value)}
                containerStyle={{ width: "100%" }}
              />
              <div className="d-flex align-items-center">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={Boolean(contact.includeinemail)}
                      onChange={(e) =>
                        onContactChange(
                          index,
                          "includeinemail",
                          e.target.checked ? 1 : 0
                        )
                      }
                    />
                  }
                  label="Include in email"
                />
                {contacts.length > 1 && (
                  <IconButton
                    size="small"
                    onClick={() => onRemoveContact(index)}
                    aria-label="Remove contact">
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </div>
          );
        })}

        <Button
          startIcon={<AddIcon />}
          onClick={onAddContact}
          size="small"
          sx={{ mt: 1 }}>
          Add Contact
        </Button>
      </div>

      {/* <div className="d-flex ms-3" style={{ marginTop: "47px" }}>
        <div className="me-4 dropdown-class w-100">
          <FormControl fullWidth>
            <InputLabel>Delivery Method</InputLabel>
            <Select
              name="DeliveryMethod"
              value={originForm.deliverymethod}
              onChange={handleChange}>
              {deliveryMethods.map((dm) => (
                <MenuItem key={dm.id} value={dm.id}>
                  {dm.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div> */}
    </div>
  );
};

export default OriginDesc;
